import { render, staticRenderFns } from "./edit-baseCardSku.vue?vue&type=template&id=71e58132"
import script from "./edit-baseCardSku.vue?vue&type=script&lang=ts"
export * from "./edit-baseCardSku.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports